/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

const workPackageTypes = {
  1: 'Result',
  2: 'Feature',
  3: 'Capability',
  4: 'Epic',
  5: 'Organization'
};

export default workPackageTypes;
